<template>
  <template v-if="isLoading">
    <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
  </template>
  <template v-else>
    <div class="yuukyuu">
      <div class="message-area">
        <div class="message info">
          <p>有給休暇が残り{{ zanYuukyuu?.zan_yuukyuu ?? 0 }}日です</p>
        </div>
        <div class="message info" v-if="zanFurikyuu && zanFurikyuu?.zan > 0">
          <p>
            振休残が{{ zanFurikyuu.zan }}日あります
          </p>
        </div>
      </div>
      <h3>有給休暇申請</h3>
      <div class="multi-date-table" v-for="(item, index) in form.yuukyuu" :key="index">
        <div class="head"><b>有給{{ (index + 1) }}</b></div>
        <div class="item flex">
          <b class="width-115">区分（取得時間）</b>
          <p>{{ divStr(item.yuukyuu_tani_type) }}（{{ timeFormat(item.yuukyuu_times) }}時間）</p>
        </div>
        <div class="item flex">
          <b class="width-115">取得日</b>
          <p>{{ item.start_date }}</p>
        </div>
        <div class="item flex">
          <b class="width-115">就業場所</b>
          <p>{{ form?.syuugyou_basyo_name }}</p>
        </div>
        <div class="itrm flex">
          <b class="width-115">就業時間</b>
          <p>{{ getWorkTime(item.start_date) }}</p>
        </div>
      </div>
      <div class="col-item">
        <b class="title">事由</b>
        <p class="pre">{{ form.shinsei_jiyuu ?? '無し' }}</p>
      </div>
      <div class="col-item">
        <b class="title">備考</b>
        <p class="pre">{{ form.notes ?? '無し' }}</p>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useForm } from "@/composable/form/form";
import { useYuukyuu } from "@/composable/shinsei/yuukyuu/yuukyuu";
import { useFurikyuu } from "@/composable/shinsei/furikyuu/furikyuu";
import { DateUtil } from "@/utils/DateUtil";
import OptionConst from '@/const/Option';
import { KoyouKeiyakuTimeForDetail, Shinsei } from "@/types/Shinsei";
import dayjs from "dayjs";

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    workTime: {
      type: Object as () => KoyouKeiyakuTimeForDetail[],
      default: null
    }
  },
  setup(props) {
    // エラー取得
    const { getError } = useForm();
    const { isLoading, getZanYuukyuu, zanYuukyuu } = useYuukyuu();
    const { zanFurikyuu, getZanFurikyuuCount } = useFurikyuu();

    const divStr = (val: number | null | undefined) => {
      if (!val) {
        return
      }
      return OptionConst.SHINSEI_DIV_OPTION.find(opt => opt.val === val)?.label
    }

    onMounted(async () => {
      zanYuukyuu.value = await getZanYuukyuu(Number(props.form.user_id))
      await getZanFurikyuuCount(Number(props.form.user_id))
    })

    const timeFormat = (time: string | null | undefined) => {
      if (!time) {
        return
      }
      let splitTime = DateUtil.splitTimeString(time)
      return (Number(splitTime?.hour) + Number(splitTime?.minutes) / 60).toFixed(2)
    }

    const getWorkTime = (date: string | Date | null) => {
      if(!date){
        return null
      }
      const d = dayjs(date)
      const id = props.form.shinsei_koyou_keiyaku_time?.find(function(v, k) {
        return d.isSame(v.target_date)
      })?.koyou_keiyaku_time_id
      const workTime = props.workTime.find(v => v.koyou_keiyaku_time_id == id) ?? null
      return workTime?.disp_work_time ?? '無し'
    }

    return {
      getError,
      divStr,
      timeFormat,
      zanYuukyuu,
      isLoading,
      zanFurikyuu,
      getWorkTime
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
